/* ============
 * Mutations for the formalities module
 * ============
 *
 * The mutations that are available on the
 * formalities module.
 */

export default {
  setJWT (state, payload) {
    state.jwt = payload
  },
  setExp (state, payload) {
    state.exp = payload
  },
  setOnboarding (state, payload) {
    state.onboarding = payload
  },
  setPossibility (state, payload) {
    state.possibility = payload
  },
  clear (state) {
    state.onboarding = 1
    state.possibility = null
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/loans/mutations.js